import { CommonModule } from '@angular/common';
import { SymbolSwitcherModule } from '../symbol-switcher/symbol-switcher.module';
import { SchwabSsoFormModule } from 'AccountsApp/ts/features/schwab_sso_form/schwab-sso-form.module';
import { AlertsModalModule } from 'AlertsApp/ts/features/alerts-modals/alerts-modal.module';
import { RegistrationStatusUpdateDropdownModule } from 'ClientManagementApp/ts/features/registration-status-update-dropdown/registration-status-update-dropdown.module';
import { CustomPdfReportModalModule } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/custom-pdf-report-modal.module';
import { IRebalPushModalModule } from 'ModelPortfolioApp/ts/shared/features/irebal-push-modal/irebal-push-modal.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { SharingModalModule } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { NotesAppModule } from 'NotesApp/ts/apps/notes-app/app.module';
import { StartRTQAssessmentModalModule } from 'RTQApp/apps/rtq-assessment-list-app/components/start-rtq-assessment-modal/start-rtq-assessment-modal.module';
import { CustomBenchmarkSelectorModalModule } from 'SecuritiesApp/ts/features/custom-benchmark-selector-modal/custom-benchmark-selector-modal.module';
import { SecurityHeaderDropdownModule } from 'SecuritiesApp/ts/features/security-header-dropdown/security-header-dropdown.module';
import { AddToWatchlistModalModule } from 'WatchlistApp/ts/features/add-to-watchlist-modal/components/add-to-watchlist-modal.module';
import * as i0 from "@angular/core";
export class SecurityHeaderControlModule {
}
SecurityHeaderControlModule.ɵfac = function SecurityHeaderControlModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityHeaderControlModule)(); };
SecurityHeaderControlModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SecurityHeaderControlModule });
SecurityHeaderControlModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddToWatchlistModalModule,
        AlertsModalModule,
        CommonModule,
        CustomBenchmarkSelectorModalModule,
        CustomPdfReportModalModule,
        IconModule,
        IRebalPushModalModule,
        NotesAppModule,
        RegistrationStatusUpdateDropdownModule,
        SchwabSsoFormModule,
        SecurityHeaderDropdownModule,
        SharingModalModule,
        SingleSelectDropdownModule,
        StartRTQAssessmentModalModule,
        SymbolSwitcherModule,
        TooltipModule] });
